import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-paper px-5 py-20 sm:py-28" data-id="element-46" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-47" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-48" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-cta-dark" data-id="element-49" data-mp="57ebob4uv5ec">
            The Physics &amp; Chemistry Ready Difference
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-50" data-mp="3rhi7yht7h0pb">
            From an Overwhelmed Teacher to a{' '}
            <span className="italic text-cta-dark" data-id="element-51" data-mp="3ifhc9pdmempr">
              Confident Science Guide.
            </span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-52" data-mp="1bp1c27lh5myx">
            Give your lessons a clear visual rhythm, your students more
            scientific confidence, and yourself the time to enjoy teaching
            again.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-53" data-mp="1fadd3ewbt2g7">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-54" data-mp="1o1dna1gt5po6" data-mpi={index}>
              <dt className="sr-only" data-id="element-55" data-mp="wcitk6xkn8jk">{stat.label}</dt>
              <dd data-id="element-56" data-mp="1aar096keto7x">
                <span className="block font-display text-3xl font-black text-cta-dark" data-id="element-57" data-mp="1aba79s8ius76">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/60" data-id="element-58" data-mp="15dqrgnw6e7d4">
                  {stat.label}
                </span>
                <span className="mt-2 block text-xs text-ink/45" data-id="element-59" data-mp="2gq1d8aci5382">
                  {stat.note}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-60" data-mp="2srsxf2ykab6z">
          <div className="grid md:grid-cols-2" data-id="element-61" data-mp="2xrfbtfq4lxhd">
            <div className="relative bg-mist p-8 sm:p-10" data-id="element-62" data-mp="2xsqcv7s6sr4s">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-63" data-mp="32ra33kdtcp2y">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-64" data-mp="2552w63u1eknf" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-65" data-mp="2a2w0erbs54l2">
                The cost of improvising
              </span>
              <h3 className="mt-3 font-display text-2xl font-bold tracking-wide text-ink" data-id="element-66" data-mp="2jso0g12nepwx">
                BEFORE
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-67" data-mp="1mbz1qg8zw3rr">
                What planning from scratch quietly takes from your week.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-68" data-mp="1jsvke4ao7tlb">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-69" data-mp="1espscn0ho52p">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-70" data-mp="14v395oc5prcx" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-71" data-mp="w1ggw875r68h">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-cta text-white" data-id="element-72" data-mp="r2vga7nzukji">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-73" data-mp="m64xvdopvcux" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-cta-dark" data-id="element-74" data-mp="h4z7vnmfy3p3">
                The Ready-to-Teach system
              </span>
              <h3 className="mt-3 font-display text-2xl font-bold tracking-wide text-ink" data-id="element-75" data-mp="11u1h6xcv57tb">
                WITH PHYSICS &amp; CHEMISTRY READY
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-76" data-mp="16vqpw6cm59e8">
                Walk into every lesson with a clear, structured plan.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-77" data-mp="x2ia4xkc55nc">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-cta-light px-4 py-3 text-sm font-medium text-ink" data-id="element-78" data-mp="j3aa62gclti3">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-cta-dark" aria-hidden="true" data-id="element-79" data-mp="a4f2elxnobco" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-paper px-6 py-4 text-center text-xs text-ink/50" data-id="element-80" data-mp="28ji21s2rtigu">
            A complete system to plan less and teach science with more purpose.
          </p>
        </div>
      </div>
    </section>;
}